// Checksum utility functions
function generateChecksum(data) {
  // Simple hash function using the created field
  let hash = 0;
  const str = data.toString();
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  // Convert to positive hex string and take first 8 characters
  return Math.abs(hash).toString(16).padStart(8, '0').substring(0, 8);
}

function generateSharingChecksum(propertyId, created) {
  return generateChecksum(`${propertyId}-${created}`)
}

function generateMeterSharingChecksum(propertyId, meterId, created) {
  return generateChecksum(`${propertyId}-${meterId}-${created}`)
}

function constructSharePointUrl(attachmentUrl) {
  // Extract domain from localStorage token
  const authData = JSON.parse(localStorage.getItem('auth') || '{}')
  const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
  const domainId = decodedToken.domainId || 1
  
  // Get domain code from domain ID
  const domain = resolveDomain(domainId)
  
  // Extract file path from attachment URL (remove :/content suffix)
  const filePath = attachmentUrl.replace(/:\/content$/, '')
  
  // Construct SharePoint base URLs based on domain
  let baseUrl, viewId
  switch (domain) {
    case 'erste-hausverwaltung-dus':
      baseUrl = 'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSDsseldorf/Freigegebene Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37' // Use the same view ID
      break
    case 'hauscon':
      baseUrl = 'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSHauscon/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'cig':
      baseUrl = 'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSCIG/Freigegebene Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'zieglmeier':
      baseUrl = 'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSZieglmeier/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'erste-hausverwaltung-2':
      baseUrl = 'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSTesting/Freigegebene Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'ehv-service':
      baseUrl = 'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSEHVService/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37' 
      break
    case 'sgv-murr':
      baseUrl = 'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSsgv-murr/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37' 
      break
    default:
      baseUrl = '/'
      viewId = ''
  }
  
  if (!baseUrl || !viewId) {
    return '#'
  }
  
  // Encode the file path for URL
  const encodedFilePath = encodeURIComponent(`/sites/${domain === 'erste-hausverwaltung-2' ? 'NeovaroDMSTesting' : 
    domain === 'erste-hausverwaltung-dus' ? 'NeovaroDMSDsseldorf' :
    domain === 'hauscon' ? 'NeovaroDMSHauscon' :
    domain === 'cig' ? 'NeovaroDMSCIG' :
    domain === 'zieglmeier' ? 'NeovaroDMSZieglmeier' : 'NeovaroDMSTesting'}/Freigegebene Dokumente/${filePath}`)
  
  // Get parent path (everything except the filename)
  const pathParts = filePath.split('/')
  const parentPath = pathParts.slice(0, -1).join('/')
  const encodedParentPath = encodeURIComponent(`/sites/${domain === 'erste-hausverwaltung-2' ? 'NeovaroDMSTesting' : 
    domain === 'erste-hausverwaltung-dus' ? 'NeovaroDMSDsseldorf' :
    domain === 'hauscon' ? 'NeovaroDMSHauscon' :
    domain === 'cig' ? 'NeovaroDMSCIG' :
    domain === 'zieglmeier' ? 'NeovaroDMSZieglmeier' : 'NeovaroDMSTesting'}/Freigegebene Dokumente/${parentPath}`)
  
  // Construct the full URL with proper parameters
  return `${baseUrl}/Forms/AllItems.aspx?viewid=${viewId}&id=${encodedFilePath}&parent=${encodedParentPath}`
}

const onPropertyPageMatch = async (pathname, regex) => {
  localStorage.setItem('isInEditMode', 'false');
  injectImpowerXStyles()
  const urlParams = pathname.match(regex)
  const propertyHrId = urlParams[1]
  const isMVProperty = propertyHrId.startsWith('MV')
  const authData = JSON.parse(localStorage.getItem('auth') || '{}')
  const token = authData.token
  let propertyData = null

  try {
  const propertyUrl = new URL(`${baseApiUrl}/services/pmp-accounting/api/v1/properties/simple/by-hr-id?propertyHrId=${propertyHrId}`)
  const propertyResponse = await fetch(propertyUrl.toString(), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  propertyData = await propertyResponse.json()
  if (!propertyData) throw new Error('Property not found')
  } catch (error) {
    console.error('Error fetching property data:', error)
  }
  const propertyId = propertyData?.id
  if (!propertyId) {
    console.error('Property ID not found')
  }

  let isDraft = false
  if (!isInRole('tech') && !isInRole('capitol') && !isInRole('ehvd') && !isInRole('zhv') && !isInRole('sgv')) return

  function getNextSectionNumber() {
    const sectionNumbers = [...document.querySelectorAll('.section-number')]
      .map(element => parseInt(element.textContent, 10))
      .filter(Number.isInteger);
    return Math.max(0, ...sectionNumbers) + 1;
  }

  function findLastSectionInsertionPoint() {
    const lastSectionNumber = getNextSectionNumber() - 1;
    const sections = document.querySelectorAll('.FormSection .section-number');
    for (const section of sections) {
      if (parseInt(section.textContent, 10) === lastSectionNumber) {
        return section.closest('.FormSection');
      }
    }
    return null;
  }

  function findLastSidebarLinkInsertionPoint() {
    const lastSectionNumber = getNextSectionNumber() - 1;
    const links = document.querySelectorAll('.FormSidebar .Link.main-link .link-title');
    for (const link of links) {
      const linkNumber = parseInt(link.textContent.trim().split('&nbsp;')[0], 10);
      if (linkNumber === lastSectionNumber) {
        return link.closest('.Link.main-link');
      }
    }
    return null;
  }

  function insertSubSectionElement(sectionName, subSectionName) {
    const section = document.querySelector(`#${sectionName}`);
    if (!section) return;
    const subSections = section.querySelectorAll('.sub-section');

    if (subSections.length) {
      const lastSubSection = subSections[subSections.length - 1];
      lastSubSection.insertAdjacentHTML('afterend', generateSubSection(subSectionName));
    } else {
      const formSectionWrapper = section.querySelector('.form-section-wrapper');
      const sectionContent = document.createElement('div');
      sectionContent.className = 'section-content';
      sectionContent.innerHTML = generateSubSection(subSectionName);
      formSectionWrapper.appendChild(sectionContent);
    }
  }

  function propertyFormSidebarLink({ id, title, hasSubSection }, sectionNumber) {
    const link = document.createElement('div');
    link.className = 'Link main-link';
    link.innerHTML = `<div class="link-row level1 ${hasSubSection ? '' : 'arrow-placeholder'}">
          ${hasSubSection ? '<div class="arrow-wrapper" role="button" tabindex="-1"><span class="arrow">▶</span></div>' : ''}
          <div class="link-title" role="button" tabindex="-1">${sectionNumber}&nbsp;&nbsp;&nbsp;&nbsp;${title || ''}</div>
        </div>
      `;
    link.dataset.sectionId = id;

    const arrowWrapper = link.querySelector('.arrow-wrapper');
    if (arrowWrapper) {
      arrowWrapper.onclick = () => {
        arrowWrapper.classList.toggle('open');
      }
    }

    link.addEventListener('click', () => {
      document.querySelectorAll('.FormSidebar .Link.main-link .link-row').forEach(row => {
        row.classList.remove('active');
      });

      link.querySelector('.link-row').classList.add('active');

      const section = document.getElementById(id);
      if (section) {
        const sectionWrapper = section.querySelector('.form-section-wrapper');
        const sectionHeader = section.querySelector('.main-section-header.section-header');
        const sectionNumberBox = section.querySelector('.section-number-box');
        const sectionTitleBox = section.querySelector('.section-title-box');

        sectionWrapper.classList.add('open');
        if (sectionHeader.classList.contains('not-open')) {
          replaceElementClass(sectionHeader, 'not-open', 'open');
          let sectionContent = sectionWrapper.querySelector('.section-content');
          if (!sectionContent) {
            const components = {
              'NotesSection': createNotesSectionContent,
              'MeterReadingsSection': createMeterReadingsSectionContent
            };
            const contentFunction = components[id];
            if (contentFunction) {
              // Handle async content functions
              if (contentFunction.constructor.name === 'AsyncFunction') {
                contentFunction().then(sectionContent => {
                  if (sectionContent) {
                    sectionContent.className = 'section-content';
                    sectionWrapper.appendChild(sectionContent);
                    sectionContent.style.display = 'block';
                  }
                });
                // Return a placeholder element for now
                sectionContent = document.createElement('div');
                sectionContent.className = 'section-content';
                sectionContent.style.display = 'none';
                sectionWrapper.appendChild(sectionContent);
              } else {
                sectionContent = contentFunction();
                sectionContent.className = 'section-content';
                sectionWrapper.appendChild(sectionContent);
              }
            }
          }
          if (sectionContent) {
            sectionContent.style.display = 'block';
          }
        }
        sectionNumberBox.classList.add('open');
        sectionTitleBox.classList.add('open');

        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    });

    const target = findLastSidebarLinkInsertionPoint();
    if (target) {
      const sidebar = document.querySelector('.FormSidebar');
      const allLinks = sidebar.querySelectorAll('.Link.main-link .link-title');

      allLinks.forEach(linkTitle => {
        const titleText = linkTitle.textContent;
        const numberMatch = titleText.match(/^(\d+)\s+/);
        if (numberMatch) {
          const currentNumber = parseInt(numberMatch[1], 10);
          if (currentNumber >= sectionNumber) {
            const newText = titleText.replace(/^\d+(\s+)/, `${currentNumber + 1}$1`);
            linkTitle.textContent = newText;
          }
        }
      });

      target.after(link);
    } else {
      const sidebar = document.querySelector('.FormSidebar');
      if (sidebar) {
        sidebar.appendChild(link);
      }
    }

    return link;
  }

  function initializeComponent(componentFunction, config) {
    const component = componentFunction(config);
    const target = findLastSectionInsertionPoint();
    if (target) {
      target.after(component);
    }
  }

  function replaceElementClass(element, oldClassName, newClassName) {
    if (element) {
      element.classList.remove(oldClassName);
      element.classList.add(newClassName);
    }
  }

  function createNoteElement(note) {
    const noteElement = document.createElement('div');
    noteElement.className = 'note-item';
    noteElement.dataset.noteId = note.id;
    noteElement.style.marginBottom = '16px';

    const userName = note.user ?
      `${window.DOMPurify.sanitize(note.user.firstName)} ${window.DOMPurify.sanitize(note.user.lastName)}` :
      'Unknown User';

    const sanitizedNote = window.DOMPurify.sanitize(note.note);

    noteElement.innerHTML = `
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8px;">
          <div style="display: flex; align-items: center; gap: 12px;">
            <div>
              <div style="font-weight: 500;">${userName}</div>
              <div style="font-size: 12px; color: rgba(0, 0, 0, 0.45);">
                ${new Date(note.createdAt).toLocaleString()}
              </div>
            </div>
          </div>
          <div style="display: flex; gap: 4px;">
            <button class="ant-btn ant-btn-text ant-btn-icon-only edit-note-btn">
              <span class="anticon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.05c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor"/>
                </svg>
              </span>
            </button>
            <button class="ant-btn ant-btn-text ant-btn-icon-only delete-note-btn">
              <span class="anticon" style="color: #ff4d4f;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="currentColor"/>
                </svg>
              </span>
            </button>
          </div>
        </div>
        <div style="font-size: 14px; line-height: 1.5; white-space: pre-wrap;">${sanitizedNote}</div>
        <div class="ant-divider" style="margin: 16px 0;"></div>
      `;

    return noteElement;
  }

  async function loadNotes(propertyHrId) {
    try {
      const token = JSON.parse(localStorage.getItem('auth')).token;
      const response = await fetch(`${baseApiUrl}/api/impowerX/properties/notes?propertyHrId=${propertyHrId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) throw new Error('Failed to load notes');
      const { notes } = await response.json();
      return notes;
    } catch (error) {
      return [];
    }
  }

  async function saveNote(propertyHrId, note, editsNoteId = null) {
    const token = JSON.parse(localStorage.getItem('auth')).token;
    const response = await fetch(`${baseApiUrl}/api/impowerX/properties/notes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ propertyHrId, note, editsNoteId }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to save note');
    }
    return data;
  }

  async function deleteNote(noteId) {
    try {
      const token = JSON.parse(localStorage.getItem('auth')).token;
      const response = await fetch(`${baseApiUrl}/api/impowerX/properties/notes?noteId=${noteId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error('Failed to delete note');
      return true;
    } catch (error) {
      throw error;
    }
  }

  function createNotesSectionContent() {
    const notesContainer = document.createElement('div');
    notesContainer.className = 'notes-container';
    notesContainer.innerHTML = `
        <div class="ant-row ant-form-item ant-form-item-with-help" style="row-gap: 0px;">
          <div class="ant-col ant-form-item-control">
            <div class="ant-form-item-control-input">
              <div class="ant-form-item-control-input-content">
                <div class="notes-container">
                  <div class="notes-input-section">
                    <textarea 
                      class="ant-input notes-textarea" 
                      data-testid="notes-textarea"
                      placeholder="Füge eine neue Notiz hinzu..."
                      style="min-height: 100px; resize: none;"
                    ></textarea>
                    <div class="notes-actions" style="display: flex; justify-content: flex-end; margin-top: 8px;">
                      <button type="button" class="ant-btn ant-btn-default Button add-note-btn" data-testid="add-note-btn">
                        <span role="img" class="anticon">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 7H9V0H7V7H0V9H7V16H9V9H16V7Z" fill="black"></path>
                          </svg>
                        </span>
                        <span>Erstellen</span>
                      </button>
                    </div>
                  </div>
                  <div class="ant-divider" style="margin-top: 8px;"></div>
                  <div class="notes-list" data-testid="notes-list" style="max-height: 400px; overflow-y: auto; margin-top: 24px;">
                    <div class="notes-loading-state" style="text-align: center; padding: 32px 0;">
                      <div class="ant-spin ant-spin-spinning">
                        <span class="ant-spin-dot ant-spin-dot-spin" style="color: black;">
                          <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.3;"></i>
                          <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.5;"></i>
                          <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.7;"></i>
                          <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.9;"></i>
                        </span>
                      </div>
                    </div>
                    <div class="notes-empty-state" style="display: none; text-align: center; padding: 32px 0; color: rgba(0, 0, 0, 0.45);">
                      Keine Notizen vorhanden.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ant-form-item-explain ant-form-item-explain-connected">
              <div role="alert" class="" style=""></div>
            </div>
          </div>
        </div>
      `;

    const addNoteBtn = notesContainer.querySelector('.add-note-btn');
    const textarea = notesContainer.querySelector('.notes-textarea');
    const notesList = notesContainer.querySelector('.notes-list');
    const emptyState = notesContainer.querySelector('.notes-empty-state');
    const loadingState = notesContainer.querySelector('.notes-loading-state');
    let editsNoteId = null;

    loadNotes(propertyHrId).then(notes => {
      loadingState.style.display = 'none';
      if (notes.length > 0) {
        emptyState.style.display = 'none';
        notes.forEach(note => {
          const noteElement = createNoteElement(note);
          notesList.appendChild(noteElement);
        });
        setTimeout(() => {
          notesContainer.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      } else {
        emptyState.style.display = 'block';
      }
    }).catch(error => {
      loadingState.style.display = 'none';
      emptyState.style.display = 'block';
      emptyState.textContent = 'Failed to load notes. Please try again later.';
    });

    addNoteBtn.addEventListener('click', async () => {
      const text = textarea.value.trim();
      if (!text) return;

      try {
        const result = await saveNote(propertyHrId, text, editsNoteId);
        if (result && result.note) {
          const noteElement = createNoteElement(result.note);
          notesList.insertBefore(noteElement, notesList.firstChild);
          textarea.value = '';
          emptyState.style.display = 'none';
          editsNoteId = null;
        } else {
          console.error('Invalid response format:', result);
          throw new Error('Invalid response format');
        }
      } catch (error) {
        console.error('Error saving note:', error);
        alert('Failed to save note. Please try again.');
      }
    });

    notesList.addEventListener('click', async (event) => {
      const deleteBtn = event.target.closest('.delete-note-btn');
      if (deleteBtn) {
        const noteElement = deleteBtn.closest('.note-item');
        const noteId = noteElement.dataset.noteId;

        if (confirm('Are you sure you want to delete this note?')) {
          try {
            await deleteNote(noteId);
            noteElement.remove();
            if (notesList.children.length === 0) {
              emptyState.style.display = 'block';
            }
          } catch (error) {
            alert('Failed to delete note. Please try again.');
          }
        }
      }

      const editBtn = event.target.closest('.edit-note-btn');
      if (editBtn) {
        const noteElement = editBtn.closest('.note-item');
        const noteText = noteElement.children[1]?.textContent;
        textarea.value = noteText;
        editsNoteId = noteElement.dataset.noteId;
        addNoteBtn.classList.add('is-editing')
        noteElement.remove();
        if (notesList.children.length === 0) {
          emptyState.style.display = 'block';
        }
      }
    });

    return notesContainer;
  }

  async function createMeterReadingsSectionContent() {
      const meterReadingsContainer = document.createElement('div');
      meterReadingsContainer.className = 'meter-readings-container';
      
      // Fetch property data once and cache it
      let propertyData = {};
      let actualPropertyId = null;
      const allMeters = [];
      
      try {
        const propertyHrId = window.location.pathname.match(/\/properties\/([^\/]+)/)?.[1];
        if (propertyHrId) {
          const token = JSON.parse(localStorage.getItem('auth'))?.token;
          if (token) {
            const propertyResponse = await fetch(`/services/pmp-accounting/api/v1/properties/${propertyHrId}`, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
            
            if (propertyResponse.ok) {
              propertyData = await propertyResponse.json();
              actualPropertyId = propertyData.id; // Cache the actual property ID
            } else {
              console.warn('Failed to fetch property data:', propertyResponse.status);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching property data:', error);
      }
      
      const buildings = propertyData.buildings || [];
      
      // Collect all meters from all buildings
      buildings.forEach(building => {
        if (building.meters && Array.isArray(building.meters)) {
          building.meters.forEach(meter => {
            allMeters.push({
              ...meter,
              buildingName: building.name,
              buildingHrId: building.buildingHrId
            });
          });
        }
      });

      // Generate meter list HTML grouped by building
      const metersListHTML = allMeters.length > 0 
        ? buildings.map(building => {
            const buildingMeters = building.meters || [];
            if (buildingMeters.length === 0) return '';
            
            const buildingMetersHTML = buildingMeters.map(meter => {
              const meterTypeText = getMeterTypeText(meter.meterType);
              const gridOperatorName = meter.gridOperator ? 
                `${meter.gridOperator.firstName || ''} ${meter.gridOperator.lastName || ''}`.trim() || 
                meter.gridOperator.companyName || 'Unbekannt' : 'Unbekannt';
              
              return `
                <div class="meter-item" style="background: white; border-bottom: 1px solid #d9d9d9; cursor: pointer; transition: background-color 0.2s ease;" data-meter-id="${meter.id}">
                <div class="meter-header" style="padding: 16px; display: flex; justify-content: space-between; align-items: center;">
                  <div style="flex: 1; display: flex; gap: 24px; align-items: center;">
                    <div style="min-width: 120px; font-weight: 500; font-size: 14px; color: rgba(0, 0, 0, 0.85); display: flex; align-items: center; gap: 8px;">
                      ${meter.meterType === 'WATER' ? `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #1890ff;"><path d="M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zM7.83 14c.37 0 .67.26.74.62.41 2.22 2.28 2.98 3.64 2.87.43-.02.79.32.79.75 0 .4-.32.73-.72.75-2.13.13-4.62-1.09-5.19-4.12-.08-.45.28-.87.74-.87z" fill="currentColor"/></svg>` : 
                        meter.meterType === 'ELECTRICITY' ? `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #faad14;"><path d="M7 2v11h3v9l7-12h-4l4-8z" fill="currentColor"/></svg>` :
                        meter.meterType === 'GAS' ? `<svg width="16" height="16" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #ff4d4f;"><path fill="currentColor" d="M143.38 17.85a8 8 0 0 0-12.63 3.41l-22 60.41l-24.16-23.41a8 8 0 0 0-11.93.89C51 87.53 40 116.08 40 144a88 88 0 0 0 176 0c0-59.45-50.79-108-72.62-126.15m40.51 135.49a57.6 57.6 0 0 1-46.56 46.55a7.7 7.7 0 0 1-1.33.11a8 8 0 0 1-1.32-15.89c16.57-2.79 30.63-16.85 33.44-33.45a8 8 0 0 1 15.78 2.68Z"/></svg>` :
                        `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: rgba(0, 0, 0, 0.45);"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/></svg>`}
                      ${meter.name || 'Unbenannter Zähler'}
                    </div>
                    <div style="min-width: 100px; font-size: 14px; color: rgba(0, 0, 0, 0.85);">
                      ${meterTypeText}
                    </div>
                    <div style="flex: 1; font-size: 14px; color: rgba(0, 0, 0, 0.85);">
                      <div style="text-decoration: underline; text-decoration-style: dotted; cursor: pointer;">${gridOperatorName}</div>
                      <div style="font-size: 12px; color: rgba(0, 0, 0, 0.45); margin-top: 2px;">Anbieter</div>
                    </div>
                    <div style="min-width: 120px; font-size: 14px; color: rgba(0, 0, 0, 0.85); text-align: right;">
                      <div style="font-weight: 500; color: rgba(0, 0, 0, 0.85);">${meter.counterNumber || 'N/A'}</div>
                      <div style="font-size: 12px; color: rgba(0, 0, 0, 0.45); margin-top: 2px;">Zählernummer</div>
                    </div>
                  </div>
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <button class="ant-btn ant-btn-text ant-btn-icon-only share-meter-btn" title="Zähler teilen" data-meter-id="${meter.id}" style="padding: 6px;">
                      <span class="anticon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" fill="currentColor"/>
                        </svg>
                      </span>
                    </button>
                    <span class="meter-expand-icon" style="font-size: 16px; color: rgba(0, 0, 0, 0.45);">▼</span>
                  </div>
                </div>
                <div class="meter-content" style="display: none; border-top: 1px solid #d9d9d9; background: #fafafa;">
                  <div style="padding: 16px;">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
                      <span style="font-weight: 600; font-size: 14px; color: rgba(0, 0, 0, 0.85);">Zählerstände</span>
                      <button class="ant-btn ant-btn-default add-reading-btn" style="font-size: 12px; height: 32px; padding: 0 16px;" data-meter-id="${meter.id}">
                        <span role="img" class="anticon">
                          <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 7H9V0H7V7H0V9H7V16H9V9H16V7Z" fill="black"></path>
                          </svg>
                        </span>
                        <span>Stand hinzufügen</span>
                      </button>
                    </div>
                    
                    <div class="readings-table" style="background: #fff; clear: both; max-width: 100%; border-radius: 0.4rem; border: 0.2rem solid #eee; overflow: hidden;">
                      <div class="readings-list">
                        <div class="readings-loading" style="display: none; padding: 16px; text-align: center;">
                          <div class="ant-spin ant-spin-spinning" style="margin-bottom: 8px;">
                            <span class="ant-spin-dot ant-spin-dot-spin" style="color: #1890ff;">
                              <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.3;"></i>
                              <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.5;"></i>
                              <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.7;"></i>
                              <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.9;"></i>
                            </span>
                          </div>
                          <div style="color: rgba(0, 0, 0, 0.65); font-size: 12px;">Lade Zählerstände...</div>
                        </div>
                        <div class="readings-empty" style="padding: 16px; text-align: center; color: rgba(0, 0, 0, 0.45); font-size: 14px;">
                          Keine Zählerstände verfügbar
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              `;
            }).join('');
            
            return `
              <div class="building-group" style="margin-bottom: 24px;">
                <div class="building-header" style="display: flex; align-items: center; gap: 8px; padding: 12px 16px; background: #f5f5f5; border-bottom: 2px solid #d9d9d9; margin-bottom: 8px;">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: rgba(0, 0, 0, 0.65);">
                    <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <h3 style="margin: 0; font-size: 16px; font-weight: 600; color: rgba(0, 0, 0, 0.85);">${building.name}</h3>
                  <span style="font-size: 14px; color: rgba(0, 0, 0, 0.45);">(${buildingMeters.length} ${buildingMeters.length === 1 ? 'Zähler' : 'Zähler'})</span>
                </div>
                <div class="building-meters" style="padding-left: 8px;">
                  ${buildingMetersHTML}
                </div>
              </div>
            `;
          }).join('')
        : `
          <div style="text-align: center; padding: 32px; color: rgba(0, 0, 0, 0.45);">
            <div style="font-size: 16px; margin-bottom: 8px;">Keine Zähler gefunden</div>
            <div style="font-size: 14px;">Für diese Immobilie sind noch keine Zähler konfiguriert.</div>
          </div>
        `;



      meterReadingsContainer.innerHTML = `
        <div class="ant-row ant-form-item ant-form-item-with-help" style="row-gap: 0px;">
          <div class="ant-col ant-form-item-control">
            <div class="ant-form-item-control-input">
              <div class="ant-form-item-control-input-content">
                <div class="meter-readings-container">
                  <div class="meter-readings-header" style="margin-bottom: 24px;">
                    <h3 style="margin: 0 0 16px 0; font-size: 16px; font-weight: 600;">Zählerstände verwalten</h3>
                    <p style="margin: 0; color: rgba(0, 0, 0, 0.65); font-size: 14px;">
                      Hier können Sie Zählerstände für alle Zähler dieser Immobilie verwalten.
                    </p>
                  </div>
                  
                  <div class="loading-state" style="text-align: center; padding: 48px 0;">
                    <div class="ant-spin ant-spin-spinning" style="margin-bottom: 16px;">
                      <span class="ant-spin-dot ant-spin-dot-spin" style="color: #1890ff;">
                        <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.3;"></i>
                        <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.5;"></i>
                        <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.7;"></i>
                        <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.9;"></i>
                        </span>
                    </div>
                    <div style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">Lade Zählerdaten...</div>
                          </div>
                  
                  <div class="meters-overview" style="display: none;">
                    <div class="meters-header" style="margin-bottom: 24px;">
                      <div style="display: flex; justify-content: flex-start; align-items: center; margin-bottom: 16px;">
                        <button class="ant-btn ant-btn-default share-property-btn" style="font-size: 12px; height: 32px; padding: 0 16px;">
                          <span role="img" class="anticon">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" fill="currentColor"/>
                            </svg>
                          </span>
                          <span>Alle Zähler teilen</span>
                        </button>
                      </div>
                      
                      <div style="position: relative; margin-bottom: 16px;">
                        <input type="text" id="meter-search" placeholder="Suche" style="width: 100%; padding: 12px 16px 12px 40px; border: 1px solid #d9d9d9; border-radius: 6px; font-size: 14px; background: white;">
                        <svg style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); width: 16px; height: 16px; color: rgba(0, 0, 0, 0.45);" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="currentColor"/>
                        </svg>
                      </div>
                    </div>
                    
                    <div class="meters-list" style="background: #fff; clear: both; max-width: 100%; border-radius: 0.4rem; border: 0.2rem solid #eee; overflow: hidden;">
                      ${metersListHTML}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ant-form-item-explain ant-form-item-explain-connected">
              <div role="alert" class="" style=""></div>
            </div>
          </div>
        </div>
      `;

      // Function to show content when everything is loaded
      function showMeterContent() {
        const loadingState = meterReadingsContainer.querySelector('.loading-state');
        const metersOverview = meterReadingsContainer.querySelector('.meters-overview');
        
        if (loadingState) loadingState.style.display = 'none';
        if (metersOverview) metersOverview.style.display = 'block';
      }

      // Helper function to get meter type text
      function getMeterTypeText(meterType) {
        const typeMap = {
          'WATER': 'Wasser',
          'GAS': 'Gas',
          'ELECTRICITY': 'Strom',
          'ENERGY': 'Strom'
        };
        return typeMap[meterType] || meterType || 'Unbekannt';
      }

      // Helper function to get meter icon
      function getMeterIcon(meterType) {
        const iconMap = {
          'WATER': `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #1890ff;">
            <path d="M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zM7.83 14c.37 0 .67.26.74.62.41 2.22 2.28 2.98 3.64 2.87.43-.02.79.32.79.75 0 .4-.32.73-.72.75-2.13.13-4.62-1.09-5.19-4.12-.08-.45.28-.87.74-.87z" fill="currentColor"/>
          </svg>`,
          'ELECTRICITY': `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #faad14;">
            <path d="M7 2v11h3v9l7-12h-4l4-8z" fill="currentColor"/>
          </svg>`,
          'GAS': `<svg width="16" height="16" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #ff4d4f;"><path fill="currentColor" d="M143.38 17.85a8 8 0 0 0-12.63 3.41l-22 60.41l-24.16-23.41a8 8 0 0 0-11.93.89C51 87.53 40 116.08 40 144a88 88 0 0 0 176 0c0-59.45-50.79-108-72.62-126.15m40.51 135.49a57.6 57.6 0 0 1-46.56 46.55a7.7 7.7 0 0 1-1.33.11a8 8 0 0 1-1.32-15.89c16.57-2.79 30.63-16.85 33.44-33.45a8 8 0 0 1 15.78 2.68Z"/></svg>`
        };
        return iconMap[meterType] || `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: rgba(0, 0, 0, 0.45);"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/></svg>`;
      }

      // Initialize meter readings API
      const meterApi = new window.MeterReadingsApi();
      
      // Ensure the API is available
      if (!window.MeterReadingsApi) {
        console.error('MeterReadingsApi not available');
        return meterReadingsContainer;
      }
      
      // Load meter readings for each meter
      async function loadMeterReadings(meterId, readingsTable) {
        try {
          // Show loading spinner
          const loadingElement = readingsTable.querySelector('.readings-loading');
          const emptyElement = readingsTable.querySelector('.readings-empty');
          const readingsList = readingsTable.querySelector('.readings-list');
          
          if (loadingElement) loadingElement.style.display = 'block';
          if (emptyElement) emptyElement.style.display = 'none';
          
          // Get domainId from localStorage token
          const authData = JSON.parse(localStorage.getItem('auth') || '{}')
          const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
          const domainId = decodedToken.domainId || 1
          
          if (!actualPropertyId) {
            console.error('Property ID not found for loading readings');
            return Promise.resolve();
          }
          
          const readings = await meterApi.getReadings(actualPropertyId, meterId, domainId);
          
                    if (readings.length > 0) {
            const readingsHTML = readings.map(reading => `
              <div class="reading-item" style="padding: 16px; border-bottom: 1px solid #d9d9d9; display: flex; justify-content: space-between; align-items: center;">
                <div style="flex: 1; display: flex; gap: 24px; align-items: center;">
                  <div style="min-width: 100px; font-size: 14px; color: rgba(0, 0, 0, 0.85);">
                    ${new Date(reading.readingDate).toLocaleDateString('de-DE')}
                  </div>
                  <div style="min-width: 80px; font-size: 14px; font-weight: 500; color: rgba(0, 0, 0, 0.85); text-align: right;">
                    ${parseFloat(reading.reading).toLocaleString('de-DE')}
                  </div>
                  <div style="flex: 1; font-size: 14px; color: rgba(0, 0, 0, 0.85);">
                    ${reading.notes ? reading.notes : '-'}
                  </div>
                </div>
                <div style="display: flex; gap: 8px;">
                  ${reading.attachmentUrl ? `
                    <a href="${constructSharePointUrl(reading.attachmentUrl)}" target="_blank" class="ant-btn ant-btn-text ant-btn-icon-only" title="Anhang öffnen" style="padding: 6px; color: #1890ff;">
                      <span class="anticon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="2" fill="none"/>
                          <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" fill="none"/>
                          <path d="M14 2v6h6" stroke="currentColor" stroke-width="2" fill="none"/>
                        </svg>
                      </span>
                    </a>
                  ` : ''}
                  <button class="ant-btn ant-btn-text ant-btn-icon-only delete-reading-btn" title="Löschen" data-reading-id="${reading.id}" style="padding: 6px; color: #ff4d4f;">
                    <span class="anticon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="currentColor"/>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            `).join('');
            
            // Hide loading spinner and show readings
            if (loadingElement) loadingElement.style.display = 'none';
            if (emptyElement) emptyElement.style.display = 'none';
            readingsTable.querySelector('.readings-list').innerHTML = readingsHTML;
          } else {
            // Hide loading spinner and show empty state
            if (loadingElement) loadingElement.style.display = 'none';
            if (emptyElement) emptyElement.style.display = 'block';
          }
        } catch (error) {
          console.error('Error loading meter readings:', error);
          // Hide loading spinner and show error
          if (loadingElement) loadingElement.style.display = 'none';
          if (emptyElement) emptyElement.style.display = 'none';
          readingsTable.querySelector('.readings-list').innerHTML = `
            <div style="padding: 12px 16px; text-align: center; color: #ff4d4f; font-size: 12px;">
              Fehler beim Laden der Zählerstände
            </div>
          `;
        }
        
        return Promise.resolve();
      }

      // Show content immediately since we're not pre-loading all readings
      showMeterContent();

      // Add search functionality
      const searchInput = meterReadingsContainer.querySelector('#meter-search');
      if (searchInput) {
        searchInput.addEventListener('input', (e) => {
          const searchTerm = e.target.value.toLowerCase();
          const meterItems = meterReadingsContainer.querySelectorAll('.meter-item');
          
          meterItems.forEach(item => {
            const meterName = item.querySelector('.meter-header div:first-child div:first-child').textContent.toLowerCase();
            const meterInfo = item.querySelector('.meter-header div:first-child div:last-child').textContent.toLowerCase();
            
            if (meterName.includes(searchTerm) || meterInfo.includes(searchTerm)) {
              item.style.display = 'block';
            } else {
              item.style.display = 'none';
            }
          });
        });
      }

      // Add click handlers for expanding/collapsing meters
      const meterItems = meterReadingsContainer.querySelectorAll('.meter-item');
      meterItems.forEach(item => {
        const header = item.querySelector('.meter-header');
        const content = item.querySelector('.meter-content');
        const expandIcon = item.querySelector('.meter-expand-icon');
        
        // Add hover effect
        header.addEventListener('mouseenter', () => {
          item.style.backgroundColor = '#fafafa';
        });
        
        header.addEventListener('mouseleave', () => {
          item.style.backgroundColor = 'white';
        });
        
        header.addEventListener('click', () => {
          const isExpanded = content.style.display !== 'none';
          
          if (isExpanded) {
            content.style.display = 'none';
            expandIcon.textContent = '▼';
          } else {
            content.style.display = 'block';
            expandIcon.textContent = '▲';
            
            // Load readings when expanding
            const meterId = item.getAttribute('data-meter-id');
            const readingsTable = content.querySelector('.readings-table');
            if (readingsTable) {
              loadMeterReadings(meterId, readingsTable);
            }
          }
        });
      });

      // Add event listeners for meter readings functionality
      const addReadingBtns = meterReadingsContainer.querySelectorAll('.add-reading-btn');

      addReadingBtns.forEach(btn => {
        btn.addEventListener('click', async () => {
          const meterId = btn.getAttribute('data-meter-id');
          const meter = allMeters.find(m => m.id === parseInt(meterId));
          
          // Create a simple modal for adding readings
          const modal = document.createElement('div');
          modal.style.cssText = `
            position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
            background: rgba(0,0,0,0.5); display: flex; align-items: center; 
            justify-content: center; z-index: 100000;
          `;
          
          modal.innerHTML = `
            <div style="background: white; padding: 24px; border-radius: 8px; min-width: 400px;">
              <h3 style="margin: 0 0 16px 0;">Neuer Zählerstand für ${meter?.name || 'Zähler'}</h3>
              <div style="margin-bottom: 16px;">
                <label style="display: block; margin-bottom: 4px; font-weight: 500;">Datum:</label>
                <input type="date" id="reading-date" class="ant-input" value="${new Date().toISOString().split('T')[0]}">
              </div>
              <div style="margin-bottom: 16px;">
                <label style="display: block; margin-bottom: 4px; font-weight: 500;">Zählerstand:</label>
                <input type="number" id="reading-value" class="ant-input" step="0.01" placeholder="0,00">
              </div>
              <div style="margin-bottom: 16px;">
                <label style="display: block; margin-bottom: 4px; font-weight: 500;">Notizen (optional):</label>
                <textarea id="reading-notes" class="ant-input" rows="3" placeholder="Zusätzliche Notizen..."></textarea>
              </div>
              <div style="margin-bottom: 16px;">
                <label style="display: block; margin-bottom: 4px; font-weight: 500;">Foto/Anhang (optional):</label>
                <input type="file" id="reading-attachment" class="ant-input" accept="image/*,.pdf" style="padding: 8px;">
                <div style="font-size: 12px; color: #666; margin-top: 4px;">PNG, JPG, PDF bis 10MB</div>
              </div>
              <div style="display: flex; gap: 8px; justify-content: flex-end;">
                <button class="ant-btn ant-btn-default" id="cancel-reading">Abbrechen</button>
                <button class="ant-btn ant-btn-primary" id="save-reading">Speichern</button>
              </div>
            </div>
          `;
          
          document.body.appendChild(modal);
          
          // Handle save
          modal.querySelector('#save-reading').addEventListener('click', async () => {
            const saveButton = modal.querySelector('#save-reading');
            const originalText = saveButton.textContent;
            
            // Prevent double submission
            if (saveButton.disabled) return;
            
            const readingDate = modal.querySelector('#reading-date').value;
            const readingValue = modal.querySelector('#reading-value').value;
            const notes = modal.querySelector('#reading-notes').value;
            const attachmentFile = modal.querySelector('#reading-attachment').files[0];
            
            if (!readingDate || !readingValue) {
              alert('Bitte füllen Sie alle Pflichtfelder aus.');
              return;
            }
            
            // Show loading state
            saveButton.disabled = true;
            saveButton.innerHTML = `
              <div style="display: flex; align-items: center; gap: 8px;">
                <div style="width: 16px; height: 16px; border: 2px solid #ffffff; border-top: 2px solid transparent; border-radius: 50%; animation: spin 1s linear infinite;"></div>
                Speichern...
              </div>
            `;
            
            try {
              // Get domainId from localStorage token
              const authData = JSON.parse(localStorage.getItem('auth') || '{}')
              const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
              const domainId = decodedToken.domainId || 1
              
              if (!actualPropertyId) {
                throw new Error('Property ID not found. Please refresh the page and try again.');
              }
              
              const newReading = await meterApi.createReading({
                propertyId: actualPropertyId,
                meterId,
                reading: readingValue,
                readingDate,
                notes: notes || null
              });
              
              // Upload attachment if file is selected
              if (attachmentFile) {
                const uploadFormData = new FormData();
                uploadFormData.append('file', attachmentFile);
                uploadFormData.append('readingId', newReading.id.toString());
                uploadFormData.append('propertyId', actualPropertyId.toString());
                uploadFormData.append('meterId', meterId.toString());

                const uploadResponse = await fetch('/api/meter-readings/upload-attachment', {
                  method: 'POST',
                  headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('auth') || '{}').token}`
                  },
                  body: uploadFormData
                });

                if (!uploadResponse.ok) {
                  const uploadError = await uploadResponse.json();
                  console.warn('File upload failed:', uploadError.error);
                  // Don't throw error here as the reading was saved successfully
                }
              }
              
              // Reload readings
              const meterItem = meterReadingsContainer.querySelector(`.add-reading-btn[data-meter-id="${meterId}"]`).closest('.meter-item');
              const readingsTable = meterItem.querySelector('.readings-table');
              if (readingsTable) {
                loadMeterReadings(meterId, readingsTable);
              }
              
              document.body.removeChild(modal);
            } catch (error) {
              alert('Fehler beim Speichern: ' + error.message);
              
              // Reset button state on error
              saveButton.disabled = false;
              saveButton.textContent = originalText;
            }
          });
          
          // Handle cancel
          modal.querySelector('#cancel-reading').addEventListener('click', () => {
            document.body.removeChild(modal);
          });
        });
      });



      // Handle edit and delete reading buttons
      meterReadingsContainer.addEventListener('click', async (event) => {
        const deleteBtn = event.target.closest('.delete-reading-btn');
        
        if (deleteBtn) {
          const readingId = deleteBtn.getAttribute('data-reading-id');
          if (confirm('Sind Sie sicher, dass Sie diesen Zählerstand löschen möchten?')) {
            try {
              await meterApi.deleteReading(readingId);
              
              // Reload readings for the specific meter
              const meterItem = deleteBtn.closest('.meter-item');
              const meterId = meterItem.getAttribute('data-meter-id');
              const readingsTable = meterItem.querySelector('.readings-table');
              if (readingsTable) {
                loadMeterReadings(meterId, readingsTable);
              }
            } catch (error) {
              alert('Fehler beim Löschen: ' + error.message);
            }
          }
        }
      });

      // Handle sharing buttons
      meterReadingsContainer.addEventListener('click', async (event) => {
        const shareMeterBtn = event.target.closest('.share-meter-btn');
        const sharePropertyBtn = event.target.closest('.share-property-btn');
        
        if (shareMeterBtn) {
          const meterId = shareMeterBtn.getAttribute('data-meter-id');
          const meter = allMeters.find(m => m.id === parseInt(meterId));
          // Get domainId from localStorage token
          const authData = JSON.parse(localStorage.getItem('auth') || '{}')
          const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
          const domainId = decodedToken.domainId || 1
          
          if (!actualPropertyId) {
            alert('Property ID nicht gefunden. Bitte laden Sie die Seite neu.');
            return;
          }
          
          // Generate checksum using property ID, meter ID and created field
          const checksum = generateMeterSharingChecksum(actualPropertyId, meterId, propertyData.created);
          const shareUrl = `${window.location.origin}/dienstleister/zaehler/${domainId}-${actualPropertyId}-${meterId}-${checksum}`;
          
          // Create sharing modal
          const modal = document.createElement('div');
          modal.style.cssText = `
            position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
            background: rgba(0,0,0,0.5); display: flex; align-items: center; 
            justify-content: center; z-index: 100000;
          `;
          
          modal.innerHTML = `
            <div style="background: white; padding: 24px; border-radius: 8px; min-width: 500px;">
              <h3 style="margin: 0 0 16px 0;">Zähler teilen</h3>
              <p style="margin: 0 0 16px 0; color: rgba(0, 0, 0, 0.65);">
                Teilen Sie diesen Link mit dem Dienstleister, um Zählerstände für <strong>${meter?.name || 'Zähler'}</strong> zu erfassen:
              </p>
              <div style="margin-bottom: 16px;">
                <input type="text" id="share-url" value="${shareUrl}" readonly style="width: 100%; padding: 8px 12px; border: 1px solid #d9d9d9; border-radius: 4px; font-family: monospace; font-size: 12px; background: #f5f5f5;">
              </div>
              <div style="display: flex; gap: 8px; justify-content: flex-end;">
                <button class="ant-btn ant-btn-default" id="cancel-share">Abbrechen</button>
                <button class="ant-btn ant-btn-primary" id="copy-share-url">Link kopieren</button>
              </div>
            </div>
          `;
          
          document.body.appendChild(modal);
          
          // Handle copy
          modal.querySelector('#copy-share-url').addEventListener('click', async () => {
            const urlInput = modal.querySelector('#share-url');
            try {
              await navigator.clipboard.writeText(urlInput.value);
              alert('Link wurde in die Zwischenablage kopiert!');
              document.body.removeChild(modal);
            } catch (error) {
              // Fallback for older browsers
              urlInput.select();
              document.execCommand('copy');
              alert('Link wurde in die Zwischenablage kopiert!');
              document.body.removeChild(modal);
            }
          });
          
          // Handle cancel
          modal.querySelector('#cancel-share').addEventListener('click', () => {
            document.body.removeChild(modal);
          });
        }
        
        if (sharePropertyBtn) {
          // Get domainId from localStorage token
          const authData = JSON.parse(localStorage.getItem('auth') || '{}')
          const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
          const domainId = decodedToken.domainId || 1
          
          if (!actualPropertyId) {
            alert('Property ID nicht gefunden. Bitte laden Sie die Seite neu.');
            return;
          }
          
          // Generate checksum using property ID and created field
          const checksum = generateSharingChecksum(actualPropertyId, propertyData.created);
          const shareUrl = `${window.location.origin}/dienstleister/zaehler/property/${domainId}-${actualPropertyId}-${checksum}`;
          
          // Create sharing modal
          const modal = document.createElement('div');
          modal.style.cssText = `
            position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
            background: rgba(0,0,0,0.5); display: flex; align-items: center; 
            justify-content: center; z-index: 100000;
          `;
          
          modal.innerHTML = `
            <div style="background: white; padding: 24px; border-radius: 8px; min-width: 500px;">
              <h3 style="margin: 0 0 16px 0;">Alle Zähler teilen</h3>
              <p style="margin: 0 0 16px 0; color: rgba(0, 0, 0, 0.65);">
                Teilen Sie diesen Link mit dem Dienstleister, um Zählerstände für <strong>alle ${allMeters.length} Zähler</strong> dieser Immobilie zu erfassen:
              </p>
              <div style="margin-bottom: 16px;">
                <input type="text" id="share-url" value="${shareUrl}" readonly style="width: 100%; padding: 8px 12px; border: 1px solid #d9d9d9; border-radius: 4px; font-family: monospace; font-size: 12px; background: #f5f5f5;">
              </div>
              <div style="display: flex; gap: 8px; justify-content: flex-end;">
                <button class="ant-btn ant-btn-default" id="cancel-share">Abbrechen</button>
                <button class="ant-btn ant-btn-primary" id="copy-share-url">Link kopieren</button>
              </div>
            </div>
          `;
          
          document.body.appendChild(modal);
          
          // Handle copy
          modal.querySelector('#copy-share-url').addEventListener('click', async () => {
            const urlInput = modal.querySelector('#share-url');
            try {
              await navigator.clipboard.writeText(urlInput.value);
              alert('Link wurde in die Zwischenablage kopiert!');
              document.body.removeChild(modal);
            } catch (error) {
              // Fallback for older browsers
              urlInput.select();
              document.execCommand('copy');
              alert('Link wurde in die Zwischenablage kopiert!');
              document.body.removeChild(modal);
            }
          });
          
          // Handle cancel
          modal.querySelector('#cancel-share').addEventListener('click', () => {
            document.body.removeChild(modal);
          });
        }
      });

      return meterReadingsContainer;
    }

  function propertyFormSection({ id, title, hasSubSection }, sectionContentFunction) {
    const sectionNumber = getNextSectionNumber();
    const section = document.createElement('div');
    section.className = 'FormSection';
    section.id = id;
    section.innerHTML = `
        <div class="form-section-wrapper">
          <div class="main-section-header section-header not-open">
            <div class="section-number-box">
              <div class="section-number">${sectionNumber}</div>
            </div>
            <div class="section-title-box">
              <div class="section-title">${title}</div>
            </div>
          </div>
        </div>
      `;

    propertyFormSidebarLink({ id, title, hasSubSection }, sectionNumber);

    function ensureSectionContentExists(wrapper) {
      let sectionContent = wrapper.querySelector('.section-content');
      if (!sectionContent) {
        // Handle async content functions
        if (sectionContentFunction.constructor.name === 'AsyncFunction') {
          sectionContentFunction().then(content => {
            if (content) {
              content.className = 'section-content';
              wrapper.appendChild(content);
              content.style.display = 'block';
            }
          });
          // Return a placeholder element for now
          sectionContent = document.createElement('div');
          sectionContent.className = 'section-content';
          sectionContent.style.display = 'none';
          wrapper.appendChild(sectionContent);
        } else {
          sectionContent = sectionContentFunction();
          sectionContent.className = 'section-content';
          wrapper.appendChild(sectionContent);
        }
      }
      return sectionContent;
    }

    function addEventListeners(section) {
      const sectionWrapper = section.querySelector('.form-section-wrapper');
      const sectionHeader = section.querySelector('.main-section-header.section-header');
      const sectionNumberBox = section.querySelector('.section-number-box');
      const sectionTitleBox = section.querySelector('.section-title-box');
      let sectionContent;

      if (section) {
        sectionHeader.addEventListener('click', () => {
          sectionWrapper.classList.toggle('open');
          if (sectionHeader.classList.contains('not-open')) {
            replaceElementClass(sectionHeader, 'not-open', 'open');
            sectionContent = ensureSectionContentExists(sectionWrapper);
            sectionContent.style.display = 'block';

            setTimeout(() => {
              section.scrollIntoView({ behavior: 'smooth' });
            }, 100);
          } else {
            replaceElementClass(sectionHeader, 'open', 'not-open');
            sectionContent = sectionWrapper.querySelector('.section-content');
            if (sectionContent) {
              sectionContent.style.display = 'none';
            }
          }

          sectionNumberBox.classList.toggle('open');
          sectionTitleBox.classList.toggle('open');
        });
      }
    }

    addEventListeners(section);
    return section;
  }

  const createMeterReadingsFormSection = (id, title) => {
    initializeComponent((config) => propertyFormSection(config, createMeterReadingsSectionContent), { id, title });
  };

  const createPropertyFormSection = (id, title, hasSubSection = false) => {
    initializeComponent((config) => propertyFormSection(config, createNotesSectionContent), { id, title, hasSubSection });
  };

  const waitForPageLoad = setInterval(() => {
    const entwurfTag = document.querySelector('span.ant-tag')
    if (entwurfTag && entwurfTag.textContent.trim() === "Entwurf") {
      isDraft = true
    }

    const propertyForm = document.querySelector('.form-content > div');
    if (propertyForm) {
      clearInterval(waitForPageLoad);
      createPropertyFormSection('NotesSection', 'Notizen');
      createMeterReadingsFormSection('MeterReadingsSection', 'Zählerstände');
      if (isMVProperty) {
        createPropertyFormSection('ServicesSection', 'Dienstleister', true);
      }
    }
  }, 500);

  const propertiesData = await getImpowerXData(`${baseApiUrl}/api/impowerX/properties?propertyHrId=${propertyHrId}`).catch(error => {
    console.error('Error fetching properties:', error);
    return {};
  });  
  const fields = Array.isArray(propertiesData?.fields) ? propertiesData?.fields : [];

  const contactsData = await getImpowerXData(`${baseApiUrl}/api/impowerX/contacts`).catch(error => {
    console.error('Error fetching contacts:', error);
    return {};
  });
  const contacts = Array.isArray(contactsData?.contacts) ? contactsData?.contacts : [];

  const contactOptions = contacts.map(contact => ({
    label: contact?.companyName ? contact.companyName : contact?.firstName + ' ' + contact?.lastName,
    value: contact?.id,
  }))

  const fieldsWithContactOptions = fields.map((field) => {
    if (field.fieldType === 'ContactComboBox') {
      return {
        ...field,
        options: [...field.options, ...contactOptions],
      }
    }
    return field
  })

  const sections = {}
  for (const field of fieldsWithContactOptions) {
    const { section, subSection, newSection } = field

    if (!sections[section]) sections[section] = {}

    if (!sections[section][subSection])
      sections[section][subSection] = { fields: [], newSectionPlacement: null }
    if (newSection)
      sections[section][subSection].newSectionPlacement = newSection
    sections[section][subSection].fields.push(field)
  }
  const observers = [];

  const observer = new MutationObserver((mutations) => {
    if (mutations[0].oldValue?.includes('open')) {
      $(mutations[0].target).closest('.main-link').find('.impowerx-sidebar-link').remove()
    }
  })
  observers.push(observer);

  const arrowWrapperToObserve = document.querySelector('.arrow-wrapper')
  if (arrowWrapperToObserve) {
    observer.observe(arrowWrapperToObserve, {
      attributeFilter: ['class'],
      attributeOldValue: true,
    })
  }

  for (let [section, subSections] of Object.entries(sections)) {
    for (let [subSection, { fields, newSectionPlacement }] of Object.entries(
      subSections
    )) {
      const subSectionSelector = `#${section} #${subSection}`

      const insertElements = () => {
        // Add section if it doesn't exist
        const elementInSection = $(subSectionSelector)
        if (newSectionPlacement?.startsWith('After:')) {
          const element = $(`#${newSectionPlacement.replace('After:', '')}`)
          if (element.length && !elementInSection.length) {
            if (element.hasClass('last')) {
              element.removeClass('last')
            }

            element.after(generateSubSection(subSection))
          }
        } else if (!newSectionPlacement && !elementInSection.length) {
          insertSubSectionElement(section, subSection)
        }

        // Add sidebar link if the section is open
        const SidebarSectionWrapper = document.querySelector('.FormSidebar .Link.main-link .link-row.level1.active')
        if (SidebarSectionWrapper) {
          const mainLinkEl = SidebarSectionWrapper.closest('.main-link')
          if (mainLinkEl && mainLinkEl.dataset.sectionId === section && !mainLinkEl.querySelector(`#sidebar-${subSection}`)) {
            $(mainLinkEl).append(generateSidebarLink(subSection))
          }
          const arrowWrapper = SidebarSectionWrapper.querySelector('.arrow-wrapper');
          if (arrowWrapper && !arrowWrapper.classList.contains('open')) {
            $(`#sidebar-${subSection}`).remove()
          }
        }

        // Scroll to the section when the sidebar link is clicked
        $(`#sidebar-${subSection}`).on('click', () => {
          setTimeout(() => {
            if ($(`#${section} .form-section-wrapper`).hasClass('open')) {
              document.querySelector(subSectionSelector).scrollIntoView({ behavior: 'smooth' })
            }
          }, 100)
        })

        let element = $(`${subSectionSelector} .sub-section-content`)

        fields.forEach((field, fieldIndex) => {
          if ($(`#${subSection} [name="${field.name}"]`).length) return

          const generateField = generateInputField({
            ...field,
            isDisabled: !isDraft,
          })

          if (fieldIndex % 2 === 0 || field.isFullWidth || fieldIndex === 0) {
            const row = document.createElement('div')
            row.className = 'sub-section-content-row impowerx-row-' + fieldIndex
            row.appendChild(generateField)

            element.append(row)
          } else {
            const previousRow = $(`#${subSection} .sub-section-content-row:last-child`)
            previousRow.append(generateField)
          }

          if(fields[fieldIndex + 1]?.isFullWidth && fieldIndex % 2 === 0) {
            const emptyColumn = document.createElement('div')
            emptyColumn.className = 'sub-section-content-column'

            const previousRow = $(`#${subSection} .sub-section-content-row:last-child`)
            previousRow.append(emptyColumn)
          }
        })
      }

      insertElements()

      // when the section is clicked (opened), insert the elements
      $(`#${section}`).on('click', () => {
        setTimeout(() => insertElements(), 100)
      })

      // when the sidebar link is clicked, insert the elements
      $(`.FormSidebar .main-link`).on('click', () => {
        setTimeout(() => {
          if ($(`#${section} .form-section-wrapper`).hasClass('open')) {
            insertElements()
          }
        }, 100)
      })
    }
  }

  const editFunction = () => {
    localStorage.setItem('isInEditMode', 'true');
    $('.ant-radio-wrapper').removeClass('ant-radio-wrapper-disabled')
    $('.ant-radio').removeClass('ant-radio-disabled')
    $('.ant-radio-input, .ant-input').removeAttr('disabled').removeAttr('readonly')

    $('.ant-checkbox-wrapper').removeClass('ant-checkbox-wrapper-disabled')
    $('.ant-checkbox').removeClass('ant-checkbox-disabled')
    $('.ant-checkbox-input').removeAttr('disabled')

    $('.ant-input-affix-wrapper').removeClass(
      'ant-input-affix-wrapper-readonly ant-input-affix-wrapper-disabled disabled'
    )
    $(
      '.ant-input-disabled, .ant-input-affix-wrapper-disabled, .ant-input-number-disabled'
    ).removeClass('ant-input-disabled ant-input-number-disabled')
    $('.ant-select').removeClass('read-only ant-select-disabled')

    // DatePicker specific
    $('.DatePicker').removeClass('read-only')
    $('.DatePicker input').removeClass('Mui-disabled Mui-disabled').removeAttr('disabled').attr('placeholder', 'TT.MM.JJJJ')
    $('.DatePicker button').show().removeAttr('disabled')
    $('.DatePicker .MuiInputBase-root').removeClass('Mui-disabled Mui-disabled')

    // Format date picker input strictly as DD.MM.YYYY with underscores for missing digits
    const formatDateInput = function($input) {
      let value = $input.val()
      
      // Remove any characters that are not numbers
      const numbersOnly = value.replace(/[^0-9]/g, '')
      
      // Limit to 8 digits (DDMMYYYY)
      const limitedNumbers = numbersOnly.substring(0, 8)
      
      // Format as DD.MM.YYYY with underscores for missing digits
      let formattedValue = ''
      const day = limitedNumbers.substring(0, 2)
      const month = limitedNumbers.substring(2, 4)
      const year = limitedNumbers.substring(4, 8)
      
      // Build formatted string with underscores
      if (day.length > 0) {
        formattedValue = day.padEnd(2, '_')
      } else {
        formattedValue = '__'
      }
      
      formattedValue += '.'
      
      if (month.length > 0) {
        formattedValue += month.padEnd(2, '_')
      } else {
        formattedValue += '__'
      }
      
      formattedValue += '.'
      
      if (year.length > 0) {
        formattedValue += year.padEnd(4, '_')
      } else {
        formattedValue += '____'
      }
      
      // Update the input value
      const cursorPosition = $input[0].selectionStart || 0
      $input.val(formattedValue)
      
      // Adjust cursor position after formatting
      // Count how many numbers we have to determine cursor position
      const numCount = limitedNumbers.length
      let newCursorPosition = cursorPosition
      
      if (numCount === 0) {
        newCursorPosition = 0
      } else if (numCount <= 2) {
        // Day section
        newCursorPosition = Math.min(numCount, 2)
      } else if (numCount <= 4) {
        // Month section (skip the dot)
        newCursorPosition = Math.min(numCount + 1, 5) // 3 digits = position 4 (after "DD.")
      } else {
        // Year section (skip both dots)
        newCursorPosition = Math.min(numCount + 2, 10) // 5 digits = position 7 (after "DD.MM.")
      }
      
      // Set cursor position
      $input[0].setSelectionRange(newCursorPosition, newCursorPosition)
    }

    $(document).on('input', '.DatePicker input', function(e) {
      formatDateInput($(this))
    })

    // Handle paste events - filter to numbers only and format
    $(document).on('paste', '.DatePicker input', function(e) {
      e.preventDefault()
      e.stopPropagation()
      
      const $input = $(this)
      const currentValue = $input.val().replace(/_/g, '') // Remove underscores for processing
      const cursorPosition = $input[0].selectionStart || 0
      
      // Get pasted data
      let pasteData = ''
      if (e.originalEvent && e.originalEvent.clipboardData) {
        pasteData = e.originalEvent.clipboardData.getData('text/plain')
      } else if (window.clipboardData) {
        pasteData = window.clipboardData.getData('Text')
      }
      
      // Remove non-numeric characters from pasted data
      const numbersOnly = pasteData.replace(/[^0-9]/g, '')
      
      if (numbersOnly.length > 0) {
        // Get numbers before and after cursor position
        const beforeCursor = currentValue.substring(0, cursorPosition).replace(/[^0-9]/g, '')
        const afterCursor = currentValue.substring(cursorPosition).replace(/[^0-9]/g, '')
        const combinedNumbers = (beforeCursor + numbersOnly + afterCursor).substring(0, 8)
        
        // Set the value and format it
        $input.val(combinedNumbers)
        formatDateInput($input)
      }
    })

    // Only target the calendar icon button, not the navigation arrows
    $('.DatePicker .MuiInputAdornment-root button').on('click', function(e) {
      const $dropdown = $(this).closest('.ant-form-item-control-input-content').find('.DatePicker .dropdown-wrapper')
      const $input = $(this).closest('.ant-form-item-control-input-content').find('input')
      const inputValue = $input.val()
      
      // Parse the input value and update calendar
      if (inputValue && window.updateDatePickerCalendar) {
        let date = null
        
        // Remove underscores and try DD.MM.YYYY format
        const cleanValue = inputValue.replace(/_/g, '')
        const dateParts = cleanValue.split('.')
        if (dateParts.length === 3) {
          const day = parseInt(dateParts[0].replace(/_/g, ''), 10)
          const month = parseInt(dateParts[1].replace(/_/g, ''), 10) - 1 // Month is 0-indexed
          const year = parseInt(dateParts[2].replace(/_/g, ''), 10)
          
          // Only create date if we have valid numbers
          if (!isNaN(day) && !isNaN(month) && !isNaN(year) && day > 0 && month >= 0 && year > 0) {
            date = new Date(year, month, day)
          }
        }
        
        // Check if date is valid and update calendar
        if (date && !isNaN(date.getTime())) {
          const calendarContainer = $dropdown[0]
          if (calendarContainer) {
            window.updateDatePickerCalendar(calendarContainer, date)
          }
        }
      }
      
      $dropdown.show()
    })

    // Use event delegation for navigation arrows
    $(document).on('click', '.DatePicker .MuiPickersCalendarHeader-iconButton', function(e) {
      e.stopPropagation()
      e.preventDefault()
      const $button = $(this)
      const direction = $button.attr('data-direction')
      const container = $button.closest('.DatePicker.dropdown-wrapper')[0]
      if (container && window.navigateDatePickerMonth && direction) {
        window.navigateDatePickerMonth(direction, container)
      }
    })

    // Stop propagation for clicks inside the modal to prevent outside click handler from firing
    $(document).on('click', '.DatePicker.dropdown-wrapper', function(e) {
      e.stopPropagation()
    })

    // Use event delegation so it works even when calendar content is regenerated
    $(document).on('click', '.DatePicker .MuiPickersDay-day', function() {
      const dateStr = $(this).attr('data-date')
      console.log('date', dateStr)
      
      if (dateStr) {
        const $input = $(this).closest('.ant-form-item-control-input-content').find('input')
        // Extract numbers from the date string (handles both DD.MM.YYYY and YYYY-MM-DD formats)
        const numbersOnly = dateStr.replace(/[^0-9]/g, '')
        // Set the numbers and let formatDateInput handle the formatting with underscores
        $input.val(numbersOnly)
        formatDateInput($input)
      }

      // dismiss the dropdown
      $(this).closest('.DatePicker .dropdown-wrapper').hide()
    })

    // Dismiss date picker modal when clicking outside
    $(document).on('click', function(e) {
      const $target = $(e.target)
      // Check if click is outside the modal and not on the calendar icon button
      if (!$target.closest('.DatePicker.dropdown-wrapper').length && 
          !$target.closest('.DatePicker .MuiInputAdornment-root button').length) {
        $('.DatePicker.dropdown-wrapper').hide()
      }
    })

    $('.impowerx-select').on('click', function (e) {
      e.stopPropagation()
      const $root = $(this)
      if ($root.hasClass('ant-select-disabled') || $root.hasClass('read-only')) {
        return
      }
      
      const $dropdown = $(this)
        .siblings('.dropdown-wrapper')
        .find('.impowerx-select-dropdown')
      
      const isDropdownVisible = !$dropdown.hasClass('ant-select-dropdown-hidden')
      
      // hide all dropdowns first
      $('.impowerx-select-dropdown').addClass('ant-select-dropdown-hidden')
      $('.ant-select-dropdown').addClass('ant-select-dropdown-hidden')
      
      // toggle: if it was visible, keep it hidden; if it was hidden, show it
      if (!isDropdownVisible) {
        $dropdown.removeClass('ant-select-dropdown-hidden')

        if ($root.hasClass('ContactComboBox')) {
          const $searchInput = $root.find('.ant-select-selection-search-input')
          $searchInput.removeAttr('disabled')
          const previousValue = $root.find('.ant-select-selection-item').text().trim()

          if (previousValue) {
            $searchInput.attr('placeholder', previousValue)
          }
          const $selectedItem = $root.find('.ant-select-selection-item')
          $selectedItem.text('').attr('title', '')

          // focus input for immediate typing
          setTimeout(() => { $searchInput.trigger('focus') }, 0)
        }
      }
    })

    $('.impowerx-currency-input').on('blur', (event) => {
      const val = $(event.target).val()
      const valNumber = val.replace(/\./g, '')

      if (isNaN(valNumber.replace(',', '.'))) {
        $(event.target).val(undefined)
      } else {
        const formatted = formatGermanNumber(valNumber, true, true)
        $(event.target).val(formatted)
      }
    })

    $('.impowerx-currency-input').on('input', (event) => {
      const val = $(event.target).val()
      const formatted = formatGermanNumber(val, false)

      if (!isNaN(Number(val.replace(/./g, '')))) {
        $(event.target).val(formatted)
      }
    })

    // hide the dropdown when clicking outside of it
    $(document).on('click', function (event) {
      if ($(event.target).closest('.dropdown-wrapper').length) {
        const $wrapper = $(event.target).closest('.dropdown-wrapper')
        const $select = $wrapper.siblings('.ant-select')

        if ($select.hasClass('ContactComboBox')) {
          const $option = $(event.target).closest('.contact-combobox-item')
          if ($option.length) {
            const idValue = $option.data('value')
            const label = $option.find('.select-menu-item').text().trim() || $option.text().trim()
            // store id separately; keep input empty to avoid showing id
            $select.data('selected-value', idValue)
            $select.find('input').val('')
            $select.find('.ant-select-selection-search-input').attr('placeholder', '')

            // display label only
            $select
              .find('.ant-select-selection-item')
              .text(label)
              .attr('title', label)
            $('.impowerx-select-dropdown').addClass('ant-select-dropdown-hidden')
          }
        }
        else {
          // Check if click is on an option item (not just anywhere in dropdown)
          const $option = $(event.target).closest('.impowerx-select-menu-item, .ant-select-item-option')
          if ($option.length) {
            const label = $option.find('.select-menu-item').text().trim() || event.target.textContent?.trim()
            $select.data('selected-value', label)
            $select.find('input').val('')
            $select.find('.ant-select-selection-item').text(label).attr('title', label)
            $select.find('.ant-select-selection-search-input').attr('placeholder', '')
            // Close the dropdown after selection
            $('.impowerx-select-dropdown').addClass('ant-select-dropdown-hidden')
          }
        }
      }

      if (!$(event.target).closest('.ant-select, .dropdown-wrapper').length) {
        $('.impowerx-select-dropdown').addClass('ant-select-dropdown-hidden')
      }
    })
    $('.file-input-button, .file-input, .impower-x, .impower-x-file-input, .file-input-label').removeAttr('disabled')
    $('.impower-x-file-input').removeAttr('disabled')
    $('.delete-button').removeAttr('disabled')
  }

  const saveFunction = async () => {
    localStorage.setItem('isInEditMode', 'false');
    const fieldsWithData = []

    $('.ant-radio-wrapper').addClass('ant-radio-wrapper-disabled')
    $('.ant-radio').addClass('ant-radio-disabled')
    $('.ant-radio-input').attr('disabled', true)

    $('.ant-checkbox-wrapper').addClass('ant-checkbox-wrapper-disabled')
    $('.ant-checkbox').addClass('ant-checkbox-disabled')
    $('.ant-checkbox-input').attr('disabled', true)

    $('.ant-select').off('click')

    // Get data from Radio Group Elements
    const switchElements = document.querySelectorAll('.SwitchElement')
    for (let i = 0; i < switchElements.length; i++) {
      const radios = switchElements[i].querySelectorAll('input[type="radio"]')
      let selectedValue = null
      radios.forEach((radio) => {
        if (radio.parentElement.classList.contains('ant-radio-checked')) {
          selectedValue = radio.value
        }
      })

      const fieldId = switchElements[i].getAttribute('data-field-id')

      fieldsWithData.push({
        fieldId,
        value: selectedValue,
        fieldType: 'RadioGroup',
        fieldName: switchElements[i].getAttribute('name'),
        propertyHrId,
      })
    }

    // Get data from Checkbox Group Elements
    const checkboxGroups = document.querySelectorAll('.ant-checkbox-group')
    for (let i = 0; i < checkboxGroups.length; i++) {
      const checkboxes = checkboxGroups[i].querySelectorAll(
        'input[type="checkbox"]'
      )
      const selectedValues = []

      checkboxes.forEach((checkbox) => {
        if (checkbox.parentElement.classList.contains('ant-checkbox-checked')) {
          selectedValues.push(checkbox.value)
        }
      })

      const fieldId = checkboxGroups[i].getAttribute('data-field-id')
      fieldsWithData.push({
        fieldId,
        value: selectedValues.join('|'),
        fieldType: 'CheckboxGroup',
        fieldName: checkboxGroups[i].getAttribute('name'),
        propertyHrId,
      })
    }

    // Get data from Dropdown Elements
    const selectElements = $('.impowerx-select')
    for (let i = 0; i < selectElements.length; i++) {
      const elment = $(selectElements[i])
      const fieldId = elment.attr('data-field-id')
      const input = elment.find('input')
      const dataSelected = elment.data('selected-value')
      const value = dataSelected ?? input.val()

      fieldsWithData.push({
        fieldId,
        value,
        fieldType: 'DropdownMenu',
        fieldName: elment.attr('name'),
        propertyHrId,
      })
    }

    const suffixedElements = document.querySelectorAll(
      '.ant-input-affix-wrapper'
    )
    for (let i = 0; i < suffixedElements.length; i++) {
      suffixedElements[i].classList.add(
        'ant-input-affix-wrapper-readonly',
        'disabled',
        'ant-input-affix-wrapper-disabled'
      )
    }

    const inputElements = document.querySelectorAll(
      '.impowerx-currency-input'
    )
    for (let i = 0; i < inputElements.length; i++) {
      const value = inputElements[i].value

      fieldsWithData.push({
        fieldId: inputElements[i].getAttribute('data-field-id'),
        value,
        fieldType: 'CurrencyInput',
        fieldName: inputElements[i].getAttribute('name'),
        propertyHrId,
      })

      inputElements[i].classList.add(
        'ant-input-disabled',
        'ant-input-number-disabled'
      )
      inputElements[i].setAttribute('readonly', true)
      inputElements[i].setAttribute('disabled', true)
    }

    // Get data from DatePicker Elements
    const datePickerElements = document.querySelectorAll('.DatePicker')
    for (let i = 0; i < datePickerElements.length; i++) {
      const datePicker = datePickerElements[i]
      const input = datePicker.querySelector('input')
      if (input) {
        let value = input.value
        // Remove underscores from the value (format: DD.MM.YYYY)
        value = value.replace(/_/g, '')
        
        // Only add if there's a value (not empty or just dots/underscores)
        if (value && value.replace(/[._]/g, '').length > 0) {
          const fieldId = datePicker.getAttribute('data-field-id')
          const fieldName = datePicker.getAttribute('name')
          
          fieldsWithData.push({
            fieldId,
            value,
            fieldType: 'DatePicker',
            fieldName,
            propertyHrId,
          })
        }
      }
    }

    // Disable DatePicker fields after saving
    $('.DatePicker').addClass('read-only')
    $('.DatePicker input').addClass('Mui-disabled Mui-disabled').attr('disabled', true).removeAttr('placeholder')
    $('.DatePicker button').hide().attr('disabled', true)
    $('.DatePicker .MuiInputBase-root').addClass('Mui-disabled Mui-disabled')

    $('.ant-select-dropdown').addClass('ant-select-dropdown-hidden')
    $('.ant-select').addClass('read-only ant-select-disabled')

    await saveImpowerXData(
      `${baseApiUrl}/api/impowerX/properties`,
      fieldsWithData
    )

    $('.file-input-button').attr('disabled', true)
    $('.file-input').attr('disabled', true)
    $('.impower-x').attr('disabled', true)
    $('.impower-x-file-input').attr('disabled', true)
    $('.impower-x-file-input').off('change')
    $('.delete-button').attr('disabled', true)

    // Refresh buildings data after save
    buildings = await refreshBuildingsData();
  }

  document
    .querySelector('.PageHeader .right-side button:last-child')
    ?.addEventListener('click', editFunction)

  listenToButtonClick('Bearbeiten', editFunction)
  listenToButtonClick('Edit', editFunction)
  listenToButtonClick('Speichern und Weiter', saveFunction)
  listenToButtonClick('Save and Continue', saveFunction)
  listenToButtonClick('Speichern', saveFunction)
  listenToButtonClick('Save', saveFunction)
  listenToButtonClick('Als Entwurf Speichern', saveFunction)
  listenToButtonClick('Save all', saveFunction)
  listenToButtonClick('Bereit zur Verbuchung', saveFunction)
  listenToButtonClick('Ready for invoice', saveFunction)

  const refreshBuildingsData = async () => {
    const buildingsData = await getImpowerXData(`${baseApiUrl}/api/impowerX/buildings?propertyHrId=${propertyHrId}`).catch(error => {
      console.error('Error fetching buildings:', error);
      return {};
    });
    return Array.isArray(buildingsData?.buildings) ? buildingsData?.buildings : [];
  };

  let buildings = await refreshBuildingsData();
  
  const processedFileUploads = new WeakSet();
  const processedFileUploadLineItems = new WeakSet();
  const processedFileInputs = new WeakSet();
  const processedFileUploadSections = new WeakSet();
  const processingFileInputs = new WeakSet();

  const hasBuildingReference = (element) => {
   return element?.getAttribute('id')?.replace(/\d/g, '')?.toLowerCase().includes('building')  
  }

  const deriveBuildingId = async (element) => {
    const closestSubSection = element?.closest('.sub-section')
    const closestFormSection = element?.closest('.FormSection')
    let buildingId = ''
    let closestBuildingSection
    if(closestSubSection && hasBuildingReference(closestSubSection)){
      closestBuildingSection = closestSubSection
    } else if(closestFormSection && hasBuildingReference(closestFormSection)) {
      closestBuildingSection = closestFormSection
    }

    if(!closestBuildingSection) return '';

    buildingId = closestBuildingSection.getAttribute('data-building-id')
    if (buildingId) return buildingId;
    const buildingNumber = parseInt(closestBuildingSection.getAttribute('id')?.replace(/\D/g, ''));
      if(Number.isNaN(buildingNumber)) return '';
      if (buildingNumber < buildings?.length) {
        buildingId = buildings[buildingNumber].id ?? '';
        if(buildingId) {
          closestBuildingSection.setAttribute('data-building-id', buildingId);
        }
      } else {
        const newBuildings = await refreshBuildingsData();
        buildingId = newBuildings?.[buildingNumber]?.id ?? '';
        if (buildingId) {
          closestBuildingSection.setAttribute('data-building-id', buildingId);
        }
      }
    
    return buildingId ?? '';
  }

  // replace existing file input and document with new file input and document elements
  const processFileUploads = async (rootElement = document.body) => {
    const existingDocumentRows = rootElement?.querySelectorAll('.FileUpload');
    if (!existingDocumentRows?.length) return;
    addLoadingOverlay(rootElement);
    let removalScheduled = false;
    try {
      const listPromises = [];
      const isInEditMode = localStorage.getItem('isInEditMode') === 'true';
      for (const documentRow of existingDocumentRows) {
        if (processedFileUploads.has(documentRow)) continue;
        processedFileUploads.add(documentRow);
        let fileInputId = '';
        const fileInput = documentRow.querySelector('input[type="file"]');
        const fileInputButton = documentRow.querySelector('button.file-input-label');
        
        if (fileInput) {
          fileInputId = fileInput?.id || '';
          const fileInputParent = fileInput.parentElement;
          const fileInputLabel = fileInputParent?.querySelector('.description-label')?.textContent?.trim() || '';
          const newfileElement = generateFileInput(fileInputId, !isInEditMode, true)
          fileInput.parentElement.removeChild(fileInput)
          if (fileInputButton) {
            fileInputButton.parentElement.removeChild(fileInputButton)
          }
          fileInputParent.appendChild(newfileElement)
          const secondRow = documentRow.querySelector('.second-row')
          if (secondRow) {
            documentRow.removeChild(secondRow)
          }
          const buildingId = await deriveBuildingId(documentRow);
          listPromises.push(getAndListPropertyDocuments({ propertyId, buildingId, fileInputId, fileInputLabel, documentRow }));
        }
      }
      if (listPromises.length > 0) {
        removalScheduled = true;
        Promise.allSettled(listPromises).finally(() => removeLoadingOverlay(rootElement));
      }
    } catch (e) {
      console.error('[ImpowerX] Failed to process file uploads', e);
    } finally {
      if (!removalScheduled) {
        removeLoadingOverlay(rootElement);
      }
    }
  };

  const processFileInput = (fileInput) => {
    if (!fileInput || fileInput?.classList?.contains('impower-x-file-input') || fileInput?.classList?.contains('Button')) return;
    if (processedFileInputs.has(fileInput)) return;
    const fileInputId = fileInput?.id || 'file-input';
    const isInEditMode = localStorage.getItem('isInEditMode') === 'true';
    const newfileElement = generateFileInput(fileInputId, !isInEditMode)
    const fileInputParent = fileInput.parentElement;
    fileInputParent.removeChild(fileInput)
    const fileInputLabel = fileInputParent.querySelector('.file-input-label');
    if (fileInputLabel) {
      fileInputParent.removeChild(fileInputLabel)
    }
    fileInputParent.appendChild(newfileElement)
    processedFileInputs.add(fileInput);
  }

  const processFileUploadLineItems = async (rootElement = document.body,) => {
    const documentRows = rootElement?.querySelectorAll('.FileUploadLine');
    if (!documentRows?.length) return;
    addLoadingOverlay(rootElement);
    let removalScheduled = false;
    try {
      const listPromises = [];
      const isInEditMode = localStorage.getItem('isInEditMode') === 'true';
      for (const documentRow of documentRows) {
        if (processedFileUploadLineItems.has(documentRow)) continue;
        processedFileUploadLineItems.add(documentRow);
        let fileInputId = '';
        const documentLine = documentRow.querySelector('.line');
        const fileInputLabel = documentLine.querySelector('div.file-name')?.textContent || documentLine?.querySelector('div.file-name > a')?.textContent;
        const fileInput = documentLine.querySelector('input[type="file"]');
        if (fileInput) {
          fileInputId = fileInput.id;
          processFileInput(fileInput)
        } else {
          fileInputId = `${fileInputLabel}-file-input`;
          const deleteBtn = documentLine.querySelector('.delete-button');
          if (deleteBtn) {
            deleteBtn.parentElement.removeChild(deleteBtn)
            const fileNameField = documentLine.querySelector('div.file-name');
            if (fileNameField) {
              fileNameField.innerHTML = fileInputLabel
            }
            const newFileInput = generateFileInput(fileInputId, !isInEditMode)
            documentLine.appendChild(newFileInput)
          }
        }
        if (fileInputId) {
          const buildingId = await deriveBuildingId(documentRow);
          listPromises.push(
              getAndListPropertyDocuments({ propertyId, buildingId, fileInputId, fileInputLabel: fileInputLabel.trim(), documentRow })
          );
        } 
      }
      if (listPromises.length > 0) {
        removalScheduled = true;
        Promise.allSettled(listPromises).finally(() => removeLoadingOverlay(rootElement));
      }
    } catch (e) {
      console.error('[ImpowerX] Failed to process file upload line items', e);
    } finally {
      if (!removalScheduled) {
        removeLoadingOverlay(rootElement);
      }
    }
  };

  const processFileUploadSections = async (sections) => {
    if (!sections?.length) return;  
    for (const section of sections) {
      if (processedFileUploadSections.has(section)) continue;
      processedFileUploadSections.add(section);
      try {
        addLoadingOverlay(section);
        await Promise.allSettled([processFileUploads(section), processFileUploadLineItems(section)]);
      } catch (e) {
        console.error('[ImpowerX] Failed to process file upload sections', e);
      } finally {
        removeLoadingOverlay(section);
      }
    }
  }

  const getSubSectionElements = async (mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        for (const node of mutation.addedNodes) {
          if(!node) continue;
          if (node?.nodeType !== 1) continue;
          if (node.classList?.contains('impower-x') || node.classList?.contains('impower-x-file-input') || node.classList?.contains('Link') || node.classList?.contains('second-row')) continue;
          if(node.classList?.contains('section-content')) {
            const subSections = node.querySelectorAll('.sub-section');
            if(subSections.length > 0) {
              await processFileUploadSections(subSections);
            }
            const formSection = node.closest('.FormSection');
            if(formSection) {
              await processFileUploadSections([formSection]);
            }
          } else if (node.classList?.contains('sub-section')) {
            await processFileUploadSections([node]);
          }
          else if (node.classList?.contains('sub-section-content')) {
            processFileUploads(node);
            processFileUploadLineItems(node);
          } else if (node.classList?.contains('FileUpload')) {
            processFileUploads(node);
          } else if (node.classList?.contains('FileUploadLine')) {
            processFileUploadLineItems(node);
          } else if (node?.querySelector && node?.querySelector('input[type="file"]')) {
            processFileInput(node.querySelector('input[type="file"]'));
          } else {
            continue;
          }
        }
      }
    }
  };

  $(document).on('change.impowerxFileInput', '.impower-x-file-input', async (event) => {
    const fileInput = event.target;
    
    // Prevent multiple simultaneous executions
    if (processingFileInputs.has(fileInput)) {
      event.target.value = ''; // Reset file input to prevent re-triggering
      return;
    }

    const files = fileInput.files;
    if (files && files.length > 0) {
      // Mark as processing
      processingFileInputs.add(fileInput);
      
      try {
        const fileInputId = fileInput.id
        const buildingId = await deriveBuildingId(fileInput);
        const parentDiv = fileInput.closest('.FileUpload') || fileInput.closest('.FileUploadLine');
        let fileInputLabel = parentDiv?.querySelector('.description-label')?.textContent?.trim()?.toLowerCase() || '';
        if (!fileInputLabel) {
          fileInputLabel = parentDiv?.querySelector('div.file-name')?.textContent?.trim()?.toLowerCase() || '';
        }
        const MAX_FILE_SIZE = (!isNaN(window?.maxFileSizeSingleMB) ? window?.maxFileSizeSingleMB : 10) * 1024 * 1024
        const MAX_TOTAL_SIZE = (!isNaN(window?.maxFileSizeTotalMB) ? window?.maxFileSizeTotalMB : 50) * 1024 * 1024

        const filesArray = Array.from(files);
        
        // Check individual file sizes
        const oversizedFiles = filesArray.filter(file => file.size > MAX_FILE_SIZE);
        if (oversizedFiles.length > 0) {
          const fileNames = oversizedFiles.map(f => f.name).join(', ');
          const maxSizeFormatted = formatFileSize(MAX_FILE_SIZE);
          showFileInputError(parentDiv, `Datei(en) zu groß: ${fileNames}. Maximale Größe pro Datei: ${maxSizeFormatted}`);
          fileInput.value = ''; // Reset file input
          return;
        }

        // Check total file size
        const totalSize = filesArray.reduce((sum, file) => sum + file.size, 0);
        if (totalSize > MAX_TOTAL_SIZE) {
          const totalSizeFormatted = formatFileSize(totalSize);
          const maxTotalFormatted = formatFileSize(MAX_TOTAL_SIZE);
          showFileInputError(fileInput.closest('.FileUpload') || fileInput.closest('.FileUploadLine'), `Gesamtgröße der Dateien (${totalSizeFormatted}) überschreitet das Limit von ${maxTotalFormatted}`);
          fileInput.value = ''; // Reset file input
          return;
        }

        await handleImpowerxFileInputChange({
          files,
          propertyId,
          buildingId,
          fileInputId,
          fileInputLabel,
          documentRow: parentDiv
        })
      } catch (error) {
        console.error('Error handling file input change:', error);
      } finally {
        // Clear processing flag and reset input value
        processingFileInputs.delete(fileInput);
        fileInput.value = ''; // Reset file input to allow selecting the same files again
      }
    }
  });


  const formSections = document.querySelectorAll('.FormSection');
  processFileUploadSections(Array.from(formSections));

  const buildingElementsObserver = new MutationObserver(getSubSectionElements);
  buildingElementsObserver.observe(document.body, { childList: true, subtree: true });
  observers.push(buildingElementsObserver);

  const cleanup = () => {
    if (typeof waitForPageLoad !== 'undefined') {
      clearInterval(waitForPageLoad);
    }
    observers.forEach(obs => {
      if (obs && typeof obs.disconnect === 'function') {
        obs.disconnect();
      }
    });
    observers.length = 0;
  };

  window.addEventListener('beforeunload', () => cleanup());

  //Cleanup on popstate(browser back / forward)
  window.addEventListener('popstate', () => cleanup());
  // Add unit-sets table to DistributionKeys section for WEG properties
  if (propertyHrId.startsWith('WEG')) {
    let propertyId = null
    let unitSetsData = []

    // Fetch property data to get propertyId
    const fetchPropertyData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem('auth'))?.token
        if (!token) throw new Error('Auth Token nicht gefunden.')

        const response = await fetch(
          `/services/pmp-accounting/api/v1/properties/${propertyHrId}`,
          {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          }
        )

        if (!response.ok) {
          throw new Error(`Failed to fetch property data: ${response.statusText}`)
        }

        const propertyData = await response.json()
        return propertyData
      } catch (error) {
        console.error('Error fetching property data:', error)
        throw error
      }
    }

    // Fetch unit-sets data
    const fetchUnitSets = async (propertyId) => {
      try {
        const token = JSON.parse(localStorage.getItem('auth'))?.token
        if (!token) throw new Error('Auth Token nicht gefunden.')

        const response = await fetch(
          `/services/pmp-accounting/api/v1/unit-sets?propertyId=${propertyId}`,
          {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          }
        )

        if (!response.ok) {
          throw new Error(`Failed to fetch unit-sets: ${response.statusText}`)
        }

        const unitSetsData = await response.json()
        return Array.isArray(unitSetsData) ? unitSetsData : []
      } catch (error) {
        console.error('Error fetching unit-sets:', error)
        return []
      }
    }

    // Create unit-sets table UI
    const createUnitSetsTable = (unitSets) => {
      const container = document.createElement('div')
      container.className = 'weg-unit-sets-container'
      container.style.cssText = `
        margin-top: 16px;
        margin-left: 64px;
        background: #fff;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
      `

      // Header with title and create button
      const header = document.createElement('div')
      header.style.cssText = `
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 24px;
        border-bottom: 1px solid #e8e8e8;
      `

      const title = document.createElement('h3')
      title.textContent = 'Einheitensets'
      title.style.cssText = `
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
      `

      const createButton = document.createElement('button')
      createButton.className = 'ant-btn ant-btn-default Button'
      createButton.innerHTML = `
        <span style="margin-right: 8px;">+</span>
        Erstellen
      `
      createButton.style.cssText = `
        display: flex;
        align-items: center;
        padding: 4px 15px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        background: #fff;
        cursor: pointer;
        font-size: 14px;
      `
      createButton.onmouseover = () => {
        createButton.style.borderColor = '#40a9ff'
        createButton.style.color = '#40a9ff'
      }
      createButton.onmouseout = () => {
        createButton.style.borderColor = '#d9d9d9'
        createButton.style.color = 'rgba(0, 0, 0, 0.85)'
      }
      createButton.onclick = () => {
        window.location.href = `/properties/${propertyHrId}/edit/unit-set/create`
      }

      header.appendChild(title)
      header.appendChild(createButton)
      container.appendChild(header)

      // Table
      const table = document.createElement('div')
      table.style.cssText = `
        width: 100%;
      `

      // Table header
      const tableHeader = document.createElement('div')
      tableHeader.style.cssText = `
        display: flex;
        padding: 12px 24px;
        background: #fafafa;
        border-bottom: 1px solid #e8e8e8;
        font-size: 12px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.45);
        text-transform: uppercase;
      `

      const titleHeader = document.createElement('div')
      titleHeader.textContent = 'TITEL'
      titleHeader.style.flex = '1'

      const unitsHeader = document.createElement('div')
      unitsHeader.textContent = 'EINHEITEN'
      unitsHeader.style.cssText = `
        flex: 0 0 150px;
        text-align: right;
        padding-right: 32px;
      `

      tableHeader.appendChild(titleHeader)
      tableHeader.appendChild(unitsHeader)
      table.appendChild(tableHeader)

      // Table rows
      if (unitSets.length === 0) {
        const emptyRow = document.createElement('div')
        emptyRow.style.cssText = `
          padding: 24px;
          text-align: center;
          color: rgba(0, 0, 0, 0.45);
        `
        emptyRow.textContent = 'Keine Einheitensets vorhanden'
        table.appendChild(emptyRow)
      } else {
        unitSets.forEach((unitSet) => {
          const row = document.createElement('div')
          row.style.cssText = `
            display: flex;
            padding: 12px 24px;
            border-bottom: 1px solid #f0f0f0;
            cursor: pointer;
            align-items: center;
          `
          row.onmouseover = () => {
            row.style.backgroundColor = '#fafafa'
          }
          row.onmouseout = () => {
            row.style.backgroundColor = 'transparent'
          }
          row.onclick = () => {
            window.location.href = `/properties/${propertyHrId}/edit/unit-set/${unitSet.id}`
          }

          const titleCell = document.createElement('div')
          titleCell.textContent = unitSet.name || 'Unbenannt'
          titleCell.style.cssText = `
            flex: 1;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            text-decoration: underline;
            text-decoration-style: dotted;
            text-underline-offset: 4px;
          `

          const unitsCell = document.createElement('div')
          const unitsCount = unitSet.units ? unitSet.units.length : 0
          unitsCell.textContent = unitsCount.toString()
          unitsCell.style.cssText = `
            flex: 0 0 150px;
            text-align: right;
            padding-right: 24px;
            color: rgba(0, 0, 0, 0.85);
          `

          row.appendChild(titleCell)
          row.appendChild(unitsCell)
          table.appendChild(row)
        })
      }

      container.appendChild(table)
      return container
    }

    const addUnitSetsTable = async () => {
      const targetElement = document.querySelector('#DistributionKeys > .form-section-wrapper.open > .section-content')
      if (targetElement) {
        // Check if table already exists in DOM to avoid duplicates
        if (targetElement.querySelector('.weg-unit-sets-container') || targetElement.querySelector('.weg-unit-sets-loading')) {
          return
        }

        // Show loading state
        const loadingDiv = document.createElement('div')
        loadingDiv.className = 'weg-unit-sets-loading'
        loadingDiv.style.cssText = `
          margin-top: 16px;
          padding: 24px;
          text-align: center;
          color: rgba(0, 0, 0, 0.45);
        `
        loadingDiv.textContent = 'Lade Einheitensets...'
        targetElement.appendChild(loadingDiv)

        try {
          // Fetch property data to get propertyId
          if (!propertyId) {
            const propertyData = await fetchPropertyData()
            propertyId = propertyData.id || propertyData.propertyId
            if (!propertyId) {
              throw new Error('Property ID not found in property data')
            }
          }

          // Fetch unit-sets
          unitSetsData = await fetchUnitSets(propertyId)

          // Remove loading state
          loadingDiv.remove()

          // Create and append table
          const table = createUnitSetsTable(unitSetsData)
          targetElement.appendChild(table)
        } catch (error) {
          console.error('Error loading unit-sets:', error)
          loadingDiv.textContent = 'Fehler beim Laden der Einheitensets'
          loadingDiv.style.color = '#ff4d4f'
        }
      }
    }

    // Wait for the element to be present and the section to be open
    let attempts = 0
    const maxAttempts = 60 // 30 seconds max (60 * 500ms)
    const waitForDistributionKeysSection = setInterval(() => {
      attempts++
      const distributionKeysSection = document.querySelector('#DistributionKeys')
      if (distributionKeysSection) {
        const sectionWrapper = distributionKeysSection.querySelector('.form-section-wrapper')
        if (sectionWrapper && sectionWrapper.classList.contains('open')) {
          addUnitSetsTable()
          clearInterval(waitForDistributionKeysSection)
        }
      }
      // Clear interval after max attempts to prevent infinite polling
      if (attempts >= maxAttempts) {
        clearInterval(waitForDistributionKeysSection)
      }
    }, 500)

    // Also observe for when the section opens
    const distributionKeysObserver = new MutationObserver(() => {
      const sectionWrapper = document.querySelector('#DistributionKeys > .form-section-wrapper')
      if (sectionWrapper && sectionWrapper.classList.contains('open')) {
        addUnitSetsTable()
      }
    })

    const distributionKeysSection = document.querySelector('#DistributionKeys')
    if (distributionKeysSection) {
      const sectionWrapper = distributionKeysSection.querySelector('.form-section-wrapper')
      if (sectionWrapper) {
        distributionKeysObserver.observe(sectionWrapper, {
          attributes: true,
          attributeFilter: ['class']
        })
      }
    }

    // Also check when clicking on the DistributionKeys section header
    const distributionKeysHeader = document.querySelector('#DistributionKeys .main-section-header')
    if (distributionKeysHeader) {
      distributionKeysHeader.addEventListener('click', () => {
        setTimeout(() => {
          addUnitSetsTable()
        }, 200)
      })
    }
  }

  // Add ZHV Accounts WEG button to cost center subsection
  const injectZHVAccountsButton = () => {
    // Only show for zieglmeier domain (1116)
    try {
      const authData = JSON.parse(localStorage.getItem('auth') || '{}');
      const decodedToken = JSON.parse(atob(authData.token.split('.')[1]));
      const domainId = decodedToken.domainId;
      
      if (domainId !== 1116 && domainId !== "zieglmeier") {
        return; // Only show for zieglmeier domain
      }
    } catch (error) {
      console.error('Error checking domain:', error);
      return;
    }
    
    const costCenterSubsection = document.querySelector('#costCenterSubsection');
    
    if (costCenterSubsection && !costCenterSubsection.querySelector('.zhv-accounts-weg-btn')) {
      const buttonContainer = document.createElement('div');
      buttonContainer.style.marginBottom = '16px';
      buttonContainer.style.display = 'flex';
      buttonContainer.style.gap = '8px';
      buttonContainer.style.alignItems = 'center';
      
      buttonContainer.innerHTML = `
        <button 
          class="ant-btn zhv-accounts-weg-btn" 
          type="button"
          style="margin-right: 8px; background-color: #000; border-color: #000; color: #fff;"
        >
          <span>Standardkonten Zieglmeier (WEG) erstellen</span>
        </button>
        <span class="zhv-accounts-status" style="font-size: 14px; color: rgba(0, 0, 0, 0.65);"></span>
      `;
      
      const firstChild = costCenterSubsection.querySelector('.sub-section-content, .form-section-wrapper');
      if (firstChild) {
        firstChild.insertBefore(buttonContainer, firstChild.firstChild);
      } else {
        costCenterSubsection.prepend(buttonContainer);
      }
      
      const button = costCenterSubsection.querySelector('.zhv-accounts-weg-btn');
      const statusSpan = costCenterSubsection.querySelector('.zhv-accounts-status');
      
      button.addEventListener('click', async () => {
        try {
          button.disabled = true;
          button.innerHTML = '<span>Wird erstellt...</span>';
          button.style.backgroundColor = '#000';
          button.style.borderColor = '#000';
          button.style.color = '#fff';
          statusSpan.textContent = '';
          
          // Get current propertyHrId from URL (in case user navigated without reload)
          const currentPath = window.location.pathname;
          const pathMatch = currentPath.match(/\/properties\/([^\/]+)/);
          const currentPropertyHrId = pathMatch ? pathMatch[1] : propertyHrId;
          
          const token = JSON.parse(localStorage.getItem('auth')).token;
          
          const response = await fetch(`${baseApiUrl}/api/zhvAccountsWEG?propertyHrId=${currentPropertyHrId}`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          const result = await response.json();
          
          if (!response.ok) {
            throw new Error(result.message || result.error || 'Fehler beim Erstellen der Accounts');
          }
          
          button.innerHTML = '<span>✓ Erfolgreich erstellt</span>';
          button.style.backgroundColor = '#52c41a';
          button.style.borderColor = '#52c41a';
          button.style.color = '#fff';
          statusSpan.style.color = '#52c41a';
          statusSpan.textContent = result.message || `${result.results?.length || 0} Unterkonten erstellt`;
          
          // Re-enable after 3 seconds
          setTimeout(() => {
            button.disabled = false;
            button.innerHTML = '<span>ZHV Accounts WEG erstellen</span>';
            button.style.backgroundColor = '#000';
            button.style.borderColor = '#000';
            button.style.color = '#fff';
          }, 3000);
          
        } catch (error) {
          console.error('Error creating ZHV accounts:', error);
          button.disabled = false;
          button.innerHTML = '<span>ZHV Accounts WEG erstellen</span>';
          button.style.backgroundColor = '#000';
          button.style.borderColor = '#000';
          button.style.color = '#fff';
          statusSpan.style.color = '#ff4d4f';
          statusSpan.textContent = error.message || 'Fehler beim Erstellen';
        }
      });
    }
  };

  // Try to inject immediately
  injectZHVAccountsButton();

  // Also watch for the element to appear with MutationObserver
  const zhvButtonObserver = new MutationObserver(() => {
    injectZHVAccountsButton();
  });

  zhvButtonObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

